import React from 'react';
import { BuildingLibraryIcon } from '@heroicons/react/24/outline';
import { formatCurrency } from '../../../utils/baseUtils';
import { cn } from '../../../components/ui/_cn';
import { dash } from './finance-cells';

// Frame 2c's Details. Every row is something Stripe told us; a row it did not
// is a dash, never a blank cell and never a guess.
//
// Method is Stripe's word translated once: an instant payout goes to a debit
// card, a standard one to a bank account, and "Instant" alone reads as a
// speed rather than a destination.
const METHODS = {
  standard: 'Standard · Bank account',
  instant: 'Instant · Card',
};

const Row = ({ label, children, last = false }) => (
  <>
    <div className={cn('py-[11px] text-fin-muted', !last && 'border-b border-fin-hair')}>{label}</div>
    <div className={cn('py-[11px] font-semibold text-fin-ink', !last && 'border-b border-fin-hair')}>{children}</div>
  </>
);

const PayoutDetailsCard = ({ detail }) => {
  const d = detail || {};

  return (
    <section className="rounded-xl border border-fin-border bg-fin-surface px-6 py-[22px]">
      <h2 className="text-[15px] font-bold tracking-[-0.01em] text-fin-ink">Details</h2>
      {/* A plain grid, not a <dl>: `Row` returns a fragment of two grid
          children, and dt/dd pairs cannot be produced that way without
          wrapper elements that would break the two-column track. */}
      <div className="mt-2 grid grid-cols-[110px_minmax(0,1fr)] gap-x-3 text-[13.5px]">
        <Row label="To">
          {d.bankName ? (
            <span className="flex items-center gap-2">
              <BuildingLibraryIcon className="h-3.5 w-3.5 shrink-0 text-fin-ink" aria-hidden="true" />
              <span className="truncate">
                {d.bankName}
                {d.bankLast4 ? <span className="font-medium text-fin-muted">{` •••• ${d.bankLast4}`}</span> : null}
              </span>
            </span>
          ) : (
            dash()
          )}
        </Row>
        <Row label="Amount">
          <span className="tabular-nums">
            {`${formatCurrency(d.amount || 0)} ${String(d.currency || 'usd').toUpperCase()}`}
          </span>
        </Row>
        {/* The Upcoming detail page's own status (spec 2026-09-22 §13):
            `method` is null — nothing has been sent yet to have a method —
            but the account on file is still where it will go, so a bank on
            record still reads "Standard · Bank account" rather than a dash. */}
        <Row label="Method">{METHODS[d.method] || (d.bankName ? METHODS.standard : dash())}</Row>
        <Row label="Descriptor" last>{d.descriptor || dash()}</Row>
      </div>
    </section>
  );
};

export default PayoutDetailsCard;
